import { SvgIconProps } from 'ui/icons/SvgIcon';

export const ReportsZeroState = ({ height = 128, width = 129, ...props }: SvgIconProps) => (
  <svg
    width={height}
    height={width}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g xmlns="http://www.w3.org/2000/svg" clipPath="url(#clip0_9074_92)">
      <path
        d="M115.84 71.808C115.839 64.1676 114.129 56.6242 110.833 49.7309C107.538 42.8377 102.742 36.7693 96.7966 31.9706C90.8511 27.172 83.907 23.7649 76.4734 21.999C69.0399 20.2332 61.3054 20.1534 53.837 21.7655C46.3686 23.3776 39.3557 26.6407 33.3125 31.3156C27.2692 35.9905 22.3488 41.9586 18.9121 48.7824C15.4753 55.6063 13.6094 63.1127 13.451 70.7515C13.2926 78.3902 14.8459 85.9676 17.9968 92.928H111.283C114.293 86.2941 115.847 79.0926 115.84 71.808Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.08 92.928H113.92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32001 92.928H11.52"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.48 92.928H119.68"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.9104 104.96C95.9104 106.24 81.8304 107.392 64.3328 107.392C46.8352 107.392 32.768 106.304 32.768 104.96C32.768 103.616 46.848 102.528 64.3328 102.528C81.8176 102.528 95.9104 103.68 95.9104 104.96Z"
        fill="#F5F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.5833 103.5H56.75C59.2221 99.6664 60.8419 95.3467 61.5 90.8331H67.8333C68.4986 95.3449 70.1179 99.663 72.5833 103.5Z"
        fill="#B56DC6"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M52 103.5H77.3333" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.75 90.8333H37.75C36.0876 90.6403 34.7764 89.3291 34.5833 87.6667V49.6667C34.7764 48.0043 36.0876 46.6931 37.75 46.5H91.5833C93.2457 46.6931 94.5569 48.0043 94.75 49.6667V67.0833"
        fill="#FAFAFA"
      />
      <path
        d="M75.75 90.8333H37.75C36.0876 90.6403 34.7764 89.3291 34.5833 87.6667V49.6667C34.7764 48.0043 36.0876 46.6931 37.75 46.5H91.5833C93.2457 46.6931 94.5569 48.0043 94.75 49.6667V67.0833V90.8333H75.75Z"
        fill="#FAFAFA"
      />
      <path
        d="M75.75 90.8333H37.75C36.0876 90.6403 34.7764 89.3291 34.5833 87.6667V49.6667C34.7764 48.0043 36.0876 46.6931 37.75 46.5H91.5833C93.2457 46.6931 94.5569 48.0043 94.75 49.6667V67.0833V90.8333H75.75Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.9166 78.1669H75.75"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.6666 65.5H48.8333C49.7078 65.5 50.4166 66.2089 50.4166 67.0833V78.1667H44.0833V67.0833C44.0833 66.2089 44.7922 65.5 45.6666 65.5Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71 71.8331H74.1666C75.0411 71.8331 75.75 72.542 75.75 73.4164V78.1664H69.4166V73.4164C69.4166 72.542 70.1255 71.8331 71 71.8331Z"
        fill="#FEE5E9"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.3333 56H61.5C62.3744 56 63.0833 56.7089 63.0833 57.5833V78.1667H56.75V57.5833C56.75 56.7089 57.4589 56 58.3333 56Z"
        fill="#E6FFF7"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M34.5833 84.5H75.75H34.5833Z" fill="#B56DC6" />
      <path
        d="M34.5833 84.5H75.75H94.75V89.25L93.1666 90.8333H37.75C35.375 90.8333 34.5833 90.8333 34.5833 88.4583V84.5Z"
        fill="#B56DC6"
      />
      <path
        d="M34.5833 84.5H75.75H94.75V89.25L93.1666 90.8333M34.5833 84.5C34.5833 84.5 34.5833 86.0833 34.5833 88.4583M34.5833 84.5V88.4583M93.1666 90.8333C93.1666 90.8333 40.125 90.8333 37.75 90.8333M93.1666 90.8333H37.75M37.75 90.8333C35.375 90.8333 34.5833 90.8333 34.5833 88.4583"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M89.7256 85.6707L93.7331 82.5114L97.4178 87.1853L93.4102 90.3446L89.7256 85.6707Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M104.908 95.8003C105.49 96.5068 105.769 97.3936 105.686 98.2656C105.603 99.1376 105.164 99.9234 104.466 100.45C103.767 100.977 102.866 101.201 101.961 101.074C101.056 100.947 100.221 100.479 99.6404 99.7724L93.068 91.7801C92.9229 91.6034 92.8531 91.3817 92.8738 91.1637C92.8946 90.9458 93.0043 90.7493 93.1788 90.6175L97.1297 87.6385C97.3044 87.507 97.5296 87.451 97.7558 87.4828C97.982 87.5145 98.1907 87.6315 98.3361 87.8081L104.908 95.8003Z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M68.3494 63.5C67.2988 65.3196 66.6169 67.3284 66.3427 69.4115C66.0684 71.4947 66.2071 73.6115 66.751 75.6411C67.2948 77.6706 68.233 79.5732 69.5121 81.2401C70.7912 82.9071 72.3861 84.3058 74.2058 85.3564C76.0254 86.4069 78.0342 87.0888 80.1174 87.3631C82.2005 87.6373 84.3173 87.4986 86.3469 86.9548C88.3764 86.411 90.279 85.4727 91.946 84.1936C93.6129 82.9145 95.0116 81.3196 96.0622 79.5C97.1128 77.6803 97.7946 75.6716 98.0689 73.5884C98.3431 71.5052 98.2044 69.3884 97.6606 67.3589C97.1168 65.3293 96.1785 63.4267 94.8994 61.7598C93.6203 60.0928 92.0254 58.6941 90.2058 57.6436C88.3861 56.593 86.3774 55.9111 84.2942 55.6368C82.211 55.3626 80.0942 55.5013 78.0647 56.0451C76.0351 56.589 74.1325 57.5272 72.4656 58.8063C70.7986 60.0854 69.3999 61.6803 68.3494 63.5Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M69.536 67.1133C68.352 70.326 68.5252 73.8893 70.0173 77.0194C71.5095 80.1495 74.1984 82.5899 77.4925 83.8039C80.7866 85.0179 84.4162 84.9059 87.5826 83.4926C90.7491 82.0793 93.1931 79.4805 94.3771 76.2678C95.561 73.0552 95.3879 69.4919 93.8957 66.3618C92.4036 63.2317 89.7147 60.7912 86.4206 59.5773C83.1264 58.3633 79.4969 58.4753 76.3304 59.8886C73.1639 61.3018 70.7199 63.9007 69.536 67.1133Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
